// Implements: F-IDN-012
/**
 * The profile photo: upload (`PUT /auth/me/avatar`) and "Usar mis iniciales" (`DELETE`). Both answer
 * the new profile, which replaces the cached one, so the page and the user menu show the new face
 * at once; the `?v=` of `avatar_url` changes with the bytes, so no stale image is served.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import type { MeSummary } from "../../../types/api";
import { ACCOUNT_ME_KEY, removeAvatar, uploadAvatar } from "../api/accountApi";

export interface UseAvatarResult {
  readonly upload: UseMutationResult<MeSummary, ApiError, Blob>;
  readonly remove: UseMutationResult<MeSummary, ApiError, null>;
}

export function useAvatar(): UseAvatarResult {
  const client = useQueryClient();
  const store = (me: MeSummary): void => {
    client.setQueryData(ACCOUNT_ME_KEY, me);
  };
  const upload = useMutation<MeSummary, ApiError, Blob>({ mutationFn: uploadAvatar, onSuccess: store });
  const remove = useMutation<MeSummary, ApiError, null>({ mutationFn: () => removeAvatar(), onSuccess: store });
  return { upload, remove };
}
